import { forwardRef } from "react";

export const LabelInput = forwardRef((props, ref) => {
  return (
    <input
      type={props?.type}
      className={`LabelInput`}
      ref={ref}
      {...props.register}
    />
  );
});
